import React, { useState, useEffect } from "react";
import { useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
    TextField,
    MenuItem,
    Button,
    Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useDispatch, useSelector } from "react-redux";
import { selectTerreni } from "../../../features/terreni/terreniSlice";
import { createParticelle, fetchParticelle, updateParticelle } from "../../../features/particelle/particelleThunk";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";

// Styled Textarea for consistent UI
const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        onChange(event);
    };

    return (
        <Textarea
            aria-label="empty textarea"
            placeholder={placeholder}
            minRows={4}
            value={inputValue}
            onChange={handleChange}
        />
    );
};

// Validation Schema
const schema = yup.object().shape({
    idParticella: yup.string().matches(/^\d+$/, "ID Particella is must be a number").required("ID Particella is required"),
    idTerreno: yup.mixed().required("ID Terreno is required"),
    citta: yup.string().required("Città è obbligatoria"),
    codiceCatastale: yup.string().required("Codice catastale is required"),
    foglioCatastale: yup.string().required("Foglio catastale is required"),
    fog: yup.string().required("Fog is required"),
    superficie: yup
  .string()
  .matches(
    /^[0-9,\.]+$/, // Allow digits, commas, and dots
    "Superficie must be a valid number with commas and dots"
  )
  .required("Superficie is required"),


  sup_grafica: yup
  .string()
  .matches(
    /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/,  // Allow numbers, commas, and dots
    "sup. grafica must be a valid number with commas and dots"
  )
  .required("sup. grafica is required"),

sup_condotta: yup
  .string()
  .matches(
    /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/,  // Allow numbers, commas, and dots
    "sup. condotta must be a valid number with commas and dots"
  )
  .required("sup. condotta is required"),


    protocollo: yup.string().required("protocollo is required"),
    cond_parz: yup
        .boolean()
        .oneOf([true, false], "cond_parz must be true or false")
        .required("cond_parz is required"),
    start_date: yup
    .date()
    .typeError("start_date data valida")
    .required("start_date acquisizione è richiesta"),
    end_date: yup
    .date()
    .typeError("end_date data valida")
    .required("end_date acquisizione è richiesta"),
    proprietario: yup.string().required("proprietario is required"),
    cultura: yup.string().required("Cultura is required"),
    varieta: yup.string().required("Varietà is required"),
    densita: yup.string().matches(/^\d+$/, "Densità is must be a number").required("Densità is required"),
    anno: yup.string().required("Anno is required"),
    certificazioni: yup.string().required("Certificazioni is required"),
     
});


const options = ["Amministratore", "Collaboratore", "Operatore"];

const ParticelleForm = ({ cantine, setCantine, singleData }) => {

    const cultureData = useSelector((store) => store.particelle.cultura)
    const varietaData = useSelector((store) => store.particelle.varieta)
    const certificazioniData = useSelector((store) => store.particelle.certificazioni)
    const { cities } = useSelector((state) => state.region);
    console.log("cittaa", cities);
    const terreniId = useSelector(selectTerreni);
    console.log(terreniId, "lllll")
    const ids = terreniId.map(item => item.nome);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => (currentYear - i).toString());
    const dispatch = useDispatch()
    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
    useEffect(() => {
        if (cantine) {
            console.log("sing", singleData);
            const terrenoObject = terreniId.find(t => t.id === singleData?.terreni_id) || null;
            setValue("idParticella", singleData?.particle_id || null);
            setValue("idTerreno", terrenoObject);
            setValue("citta", singleData?.citta || null);
            setValue("codiceCatastale", singleData?.codice_catastale || null);
            setValue("foglioCatastale", singleData?.foglio_catastale || null);
            setValue("fog", singleData?.fog || null);
            setValue("superficie", singleData?.superficie || null);
            setValue("sup_grafica", singleData?.sup_grafica || null);
            setValue("sup_condotta", singleData?.sup_condotta || null);
            setValue("protocollo", singleData?.protocollo || null);
            setValue("start_date", singleData?.start_date);
            setValue("end_date", singleData?.end_date || null);
            setValue("proprietario", singleData?.proprietario || null);
            setValue("cond_parz", singleData?.cond_parz === 1 || singleData?.cond_parz === "1");
            setValue("cultura", singleData?.cultura || null);
            setValue("varieta", singleData?.varieta || null);
            setValue("densita", singleData?.densita || null);
            setValue("anno", singleData?.anno || null);
            setValue("certificazioni", singleData?.certificazioni || null);
            setValue("note", singleData?.note || "");
        }
    }, [singleData, reset, setValue]);

    const onSubmit = async (data) => {
        try {
            const particelleData = {
                terreni_id: data.idTerreno?.id,
                particle_id: data.idParticella,
                citta: data.citta,
                codice_catastale: data.codiceCatastale,
                foglio_catastale: data.foglioCatastale,
                fog: data.fog,
                superficie: data.superficie,
                sup_grafica: data.sup_grafica,
                sup_condotta: data.sup_condotta,
                protocollo: data.protocollo,
                start_date: data.start_date ? dayjs(data.start_date).format("YYYY-MM-DD") : null,
                end_date: data.end_date ? dayjs(data.end_date).format("YYYY-MM-DD") : null,
                proprietario: data.proprietario,
                cond_parz: data.cond_parz,
                cultura: data.cultura,
                varieta: data.varieta,
                densita: data.densita,
                anno: data.anno,
                certificazioni: data.certificazioni,
                note: data.note,
            };
            const response = !cantine ? await dispatch(createParticelle(particelleData)).unwrap() : await dispatch(updateParticelle({ id: singleData?.id, data: particelleData })).unwrap();
            if (response.success) {
                dispatch(fetchParticelle());
                setCantine(false)
                localStorage.removeItem("particelle")
                reset({
                    idParticella: "",
                    idTerreno: null,
                    city: "",
                    codiceCatastale: "",
                    foglioCatastale: "",
                    fog: "",
                    superficie: "",
                    sup_grafica: "",
                    sup_condotta: "",
                    protocollo: "",
                    start_date: "",
                    end_date: "",
                    proprietario: "",
                    cond_parz: "",
                    cultura: "",
                    varieta: "",
                    densita: "",
                    anno: "",
                    certificazioni: "",
                    note: "",
                });
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
            <Controller 
            defaultValue=""
                name="idParticella"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="ID Particella"
                        fullWidth
                        margin="normal"
                        error={!!errors.idParticella}
                        helperText={errors.idParticella?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="idTerreno"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        options={terreniId}
                        getOptionLabel={(option) => option.nome || ''}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={field.value || null}
                        onChange={(event, value) => field.onChange(value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="ID Terreno"
                                className="customTextBox autoCompleteTextBox"
                                margin="normal"
                                fullWidth
                                error={!!errors.idTerreno}
                                helperText={errors.idTerreno?.message}
                            />
                        )}
                    />
                )}
            />

            <Controller
              name="citta"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={cities?.map((city) => city.comune) || []}
                  value={field.value || ""}
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Città"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.citta}
                      helperText={errors.citta?.message}
                    />
                  )}
                />
              )}
            />

            <Controller 
            defaultValue=""
                name="codiceCatastale"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Codice Catastale"
                        fullWidth
                        margin="normal"
                        error={!!errors.codiceCatastale}
                        helperText={errors.codiceCatastale?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="foglioCatastale"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Foglio Catastale"
                        fullWidth
                        margin="normal"
                        error={!!errors.foglioCatastale}
                        helperText={errors.foglioCatastale?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="fog"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="FOG"
                        fullWidth
                        margin="normal"
                        error={!!errors.fog}
                        helperText={errors.fog?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="superficie"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Superficie (Ha,Aa,Ca)"
                        fullWidth
                        margin="normal"
                        error={!!errors.superficie}
                        helperText={errors.superficie?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="sup_grafica"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Sup.grafica (Ha)"
                        fullWidth
                        margin="normal"
                        error={!!errors.sup_grafica}
                        helperText={errors.sup_grafica?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="sup_condotta"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Sup.condotta (Ha)"
                        fullWidth
                        margin="normal"
                        error={!!errors.sup_condotta}
                        helperText={errors.sup_condotta?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="protocollo"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Forma di conduzione e n. protocollo"
                        fullWidth
                        margin="normal"
                        error={!!errors.protocollo}
                        helperText={errors.protocollo?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="proprietario"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Proprietario"
                        fullWidth
                        margin="normal"
                        error={!!errors.proprietario}
                        helperText={errors.proprietario?.message}
                    />
                )}
            />

        <Controller
          defaultValue=""
            name="cond_parz"
            control={control}
            render={({ field }) => (
              <TextField
                select
                className="customTextBox"
                {...field}
                label="cond_parz"
                fullWidth
                margin="normal"
                error={!!errors.cond_parz}
                helperText={errors.cond_parz?.message}
              >
                <MenuItem value={true}>SI</MenuItem>
                <MenuItem value={false}>NO</MenuItem>
              </TextField>
            )}
          />

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <Controller
            defaultValue=""
            name="start_date"
            control={control}
            render={({ field }) => (
              <DatePicker
                className='datePickerField'
                label="Data Iniz. Cond."
                value={field.value ? dayjs(field.value) : null}
                onChange={(newValue) => field.onChange(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "normal",
                    className: "customTextBox",
                    error: !!errors.start_date,
                    helperText: errors.start_date?.message
                  }
                }}
              />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <Controller
            defaultValue=""
            name="end_date"
            control={control}
            render={({ field }) => (
              <DatePicker
                className='datePickerField'
                label="Data Fine. Cond."
                value={field.value ? dayjs(field.value) : null}
                onChange={(newValue) => field.onChange(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "normal",
                    className: "customTextBox",
                    error: !!errors.end_date,
                    helperText: errors.end_date?.message
                  }
                }}
              />
            )}
          />
        </LocalizationProvider>

            <Controller 
            defaultValue=""
                name="cultura"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        options={cultureData}
                        value={field.value || null}
                        onChange={(event, value) => setValue("cultura", value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Cultura"
                                className="customTextBox autoCompleteTextBox"
                                margin="normal"
                                fullWidth
                                error={!!errors.cultura}
                                helperText={errors.cultura?.message}
                            />
                        )}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="varieta"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        options={varietaData}
                        value={field.value || null} // ✅ Ensure value is set
                        onChange={(event, value) => setValue("varieta", value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Varieta"
                                className="customTextBox autoCompleteTextBox"
                                margin="normal"
                                fullWidth
                                error={!!errors.varieta}
                                helperText={errors.varieta?.message}
                            />
                        )}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="densita"
                control={control}
                render={({ field }) => (
                    <TextField
                        className="customTextBox"
                        {...field}
                        value={field.value || ""}
                        label="Densita"
                        fullWidth
                        margin="normal"
                        error={!!errors.densita}
                        helperText={errors.densita?.message}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="anno"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        options={years}
                        value={field.value || null}
                        onChange={(event, value) => setValue("anno", value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Anno"
                                className="customTextBox autoCompleteTextBox"
                                margin="normal"
                                fullWidth
                                error={!!errors.anno}
                                helperText={errors.anno?.message}
                            />
                        )}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="certificazioni"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        options={certificazioniData}
                        value={field.value || null}
                        onChange={(event, value) => setValue("certificazioni", value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Certificazioni"
                                className="customTextBox autoCompleteTextBox"
                                margin="normal"
                                fullWidth
                                error={!!errors.certificazioni}
                                helperText={errors.certificazioni?.message}
                            />
                        )}
                    />
                )}
            />

            <Controller 
            defaultValue=""
                name="note"
                control={control}
                render={({ field }) => (
                    <EmptyTextarea placeholder="Note" {...field} />
                )}
            />

            <div className="btnPart1">
                <Button type="submit" variant="contained">
                    Salva dati
                </Button>
            </div>
        </div>
    </form>
    );
};

export default ParticelleForm;
